module.exports = __webpack_public_path__ + "img/removeAttachment.e3304799.svg";